module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isFullActive) ? _c('div', [(_vm.loading) ? _c('div', {
    attrs: {
      "id": "overlay"
    }
  }, [_c('div', {
    staticClass: "loader"
  })]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-02c3f81e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prefab/structures/loaderFullScreen.vue
// module id = 1842
// module chunks = 1